import { isMobile } from '@common/device-manager';
import { getAirbridgeDeeplinks } from '@common/marketing-tracker';
import { KrPromotionEventQrLandingPopup, Popup } from '@common/overlay-manager';

export function dialogOnlyForApp({ deepLinkUrl }: { deepLinkUrl: string }) {
  if (!isMobile()) {
    const resolveVoid = () => {
      // do nothing
    };
    return Popup.open(KrPromotionEventQrLandingPopup()).then(resolveVoid);
  }

  const { airbridgeDeeplinks } = getAirbridgeDeeplinks();
  return airbridgeDeeplinks({ deeplink: deepLinkUrl, ctaParams: { cta_param_1: '' } });
}
